module.exports = __webpack_public_path__ + "static/img/newVersion_head.0a93448c.png";